import { render } from "./oth_cowClicker.vue?vue&type=template&id=417e21db&scoped=true"
import script from "./oth_cowClicker.vue?vue&type=script&lang=js"
export * from "./oth_cowClicker.vue?vue&type=script&lang=js"

import "./oth_cowClicker.vue?vue&type=style&index=0&id=417e21db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417e21db"]])

export default __exports__